import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "index"
};
const _hoisted_3 = { class: "fv" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "p_1" }, [
    /*#__PURE__*/ _createTextVNode(" 多業種・多様な経験を持ったメンターが、総力で"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc2" }),
    /*#__PURE__*/ _createTextVNode("あなたのビジネスに関する困りごとを解決します。 ")
], -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "p_2" }, [
    /*#__PURE__*/ _createTextVNode("中小企業経営者向けの定額クラウド・ビジネス相談窓口"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("「ShareMentors」")
], -1);
const _hoisted_7 = { class: "wrapper_1 home-wrapper" };
const _hoisted_8 = { class: "inner2 home-inner" };
const _hoisted_9 = { class: "sec1" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors とは？", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" 中小企業のビジネス課題に、様々な経験者が応えます。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" ビジネスに関する困りごとを、web上で質問投稿すると厳選された多業種・多様な経験者がすぐに回答してくれる仕組みです。ひとりの回答でなく、複数メンターの回答を得ることができるので最適な判断につながります。更に、公開されたQ＆Aの内容を参照することによっても知見を得ることができます。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" 個人事業主や小規模の中小企業には、IT・マーケティングなど専門部門がなくて代表者が代行されているケースが多いですが、それを補完できるサービスを目的としています。"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" ビジネス上の様々な疑問について気軽に相談ができて、中小企業の成長に貢献できることを目指しています。"),
    /*#__PURE__*/ _createElementVNode("br")
], -1);
const _hoisted_12 = { class: "step" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "sec1" }, [
    /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の相談分野"),
    /*#__PURE__*/ _createElementVNode("p", null, "ＩＴ系を中心に次のような職種の専門家に相談できます。"),
    /*#__PURE__*/ _createElementVNode("ul", { class: "category" }, [
        /*#__PURE__*/ _createElementVNode("li", null, "・経営/事業"),
        /*#__PURE__*/ _createElementVNode("li", null, "・マーケ/広報"),
        /*#__PURE__*/ _createElementVNode("li", null, "・営業"),
        /*#__PURE__*/ _createElementVNode("li", null, "・販売/サービス"),
        /*#__PURE__*/ _createElementVNode("li", null, "・ITエンジニア"),
        /*#__PURE__*/ _createElementVNode("li", null, "・クリエイター")
    ])
], -1);
const _hoisted_14 = { class: "sec2" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の相談ケース", -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", null, "次のようなことでお困りの方に向けたサービスです。", -1);
const _hoisted_17 = { class: "sec3" };
const _hoisted_18 = { class: "inner" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("h3", null, "ShareMentors の特長", -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("p", null, "相談者にとって、次のような特長・メリットがあります。", -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "1", -1);
const _hoisted_22 = { class: "title" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "複数名の回答", -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " １対１のメンターではなく、一度に複数のメンターから回答を得ることができるので、最適な判断につながります。 ", -1);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "2", -1);
const _hoisted_26 = { class: "title" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "回答の質が高い", -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " 不特定多数の回答者ではなく、厳選されたメンターが登録されており、かつ過去の回答状況・評価も分かります。 ", -1);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "3", -1);
const _hoisted_30 = { class: "title" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "回答が早い", -1);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " 毎回詳しい人を探す必要がありません。クラウド・サービスなので短時間に回答を得ることができます。 ", -1);
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "4", -1);
const _hoisted_34 = { class: "title" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "安価", -1);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " 複数分野の士業、コンサルタント、専門家と契約するよりは安価にご利用できます。 ", -1);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "5", -1);
const _hoisted_38 = { class: "title" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", { class: "t_1" }, "ナレッジ共有", -1);
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("div", { class: "account" }, " 公開された他者の相談と回答を参照することによっても知見を得ることができます。 ", -1);
const _hoisted_41 = { class: "plate" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("h4", null, "他サービスとの比較", -1);
const _hoisted_43 = { class: "sec4" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("h3", null, "相談イメージ", -1);
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "1"),
    /*#__PURE__*/ _createElementVNode("p", null, "相談と回答･･･チャット方式で相談者は各メンターとQ＆A")
], -1);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("div", { class: "step" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "no" }, "2"),
    /*#__PURE__*/ _createElementVNode("p", null, "相談終了…相談者によるランキングとコメント入力")
], -1);
const _hoisted_47 = { class: "sec5" };
const _hoisted_48 = { class: "inner" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("h3", null, "料金プラン", -1);
const _hoisted_50 = { class: "price_box" };
const _hoisted_51 = /*#__PURE__*/ _createStaticVNode("<li><div class=\"title\"> </div><div class=\"t1\"><p>基本料金</p></div><div class=\"t2\"><p>相談回数</p></div><div class=\"t3\"><p>追加相談</p></div><div class=\"t4\"><p>公開Q＆A閲覧</p></div><div class=\"bt_box\"></div></li>", 1);
const _hoisted_52 = { class: "title" };
const _hoisted_53 = { class: "t1" };
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("p", { class: "tt" }, "基本料金", -1);
const _hoisted_55 = { class: "price" };
const _hoisted_56 = { class: "t2" };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("p", { class: "tt" }, "相談回数", -1);
const _hoisted_58 = { class: "t3" };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("p", { class: "tt" }, "追加相談", -1);
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("div", { class: "t4" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "tt" }, "公開Q＆A閲覧"),
    /*#__PURE__*/ _createTextVNode(" 無制限 ")
], -1);
const _hoisted_61 = { class: "bt_box" };
const _hoisted_62 = ["onClick"];
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("div", { class: "under" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "※表示価格はすべて税込です。"),
    /*#__PURE__*/ _createElementVNode("p", null, "※1つの相談に対してQ＆Aが繰り返され、終了が確定するまでを１件（１チケット）とします。"),
    /*#__PURE__*/ _createElementVNode("p", null, "※初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
    /*#__PURE__*/ _createElementVNode("p", null, "　・申込日が1～15日：基本料金を全額支払い（相談回数は基本と同数）"),
    /*#__PURE__*/ _createElementVNode("p", null, "　・申込日が16～末日：基本料金を半額支払い（相談回数は基本の半数）")
], -1);
const _hoisted_64 = /*#__PURE__*/ _createStaticVNode("<div class=\"sec6\"><h3>よくあるご質問</h3><h4>契約・申込</h4><ul class=\"faq\"><li>最小契約期間は？</li><li>１カ月です。日割り計算は行いません。</li><li>できれば自身や自社の情報を公開したくないのですが？</li><li>表示名、業種は必須で公開表示されますが、会社情報や本名は任意です。</li><li>回答に対してどこまで責任を持っていますか？</li><li> 当社、およびメンターは相談の回答に従って生じた損害について責任を負いません。ただし、当社はスキルとコミュニケーション能力の高いメンターを確保することに尽力します。 </li></ul><h4>相談・回答</h4><ul class=\"faq\"><li>回答が１件も無かった場合は？</li><li>相談１件としてカウントされません。</li><li>満足いく回答が無かった場合は？</li><li>回答が１件でもあれば、相談１件としてカウントされます。（課金されます）</li><li>ビデオ会議には対応していますか？</li><li>現状はチャット方式のみです。</li></ul><h4>決済</h4><ul class=\"faq\"><li>支払い方法は？</li><li>クレジットカードによるお支払い（VISA/Master/JCB/AMEX）となります。</li></ul></div>", 1);
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
import { PlanCategory, UserType } from '@util/Consts';
import InertiaUtil from '@util/InertiaUtil';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        common: null,
        mentor_count: null,
        question_count: null,
        plans: null
    },
    setup(__props) {
        const props = __props;
        const showMonthlyAmount = (id, amount) => {
            if (id === PlanCategory.FREE_PLAN) {
                return '無料';
            }
            else if (amount) {
                return `${amount.toLocaleString()}円/月`;
            }
            return '';
        };
        const showQuestionCount = (id, count) => {
            if (id === PlanCategory.FREE_PLAN) {
                return '相談は不可';
            }
            else {
                return `${count}件以内/月`;
            }
        };
        const showAddQuestionAmount = (id, amount) => {
            if (id === PlanCategory.FREE_PLAN) {
                return 'ー';
            }
            else if (amount) {
                return `${amount.toLocaleString()}円/件`;
            }
            return '';
        };
        const onClickSignUp = (planId) => {
            const form = InertiaUtil.getForm({
                type: UserType.QUESTIONER,
                plan_id: planId,
            });
            form.get(route('signup'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _hoisted_6,
                                _createVNode(ImageFrame, { src: "images/index/i_fv.png" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _hoisted_10,
                                    _hoisted_11,
                                    _createElementVNode("ul", _hoisted_12, [
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_1.png" })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, {
                                                class: "pc",
                                                src: "images/index/sec1_2.png"
                                            }),
                                            _createVNode(ImageFrame, {
                                                class: "sp",
                                                src: "images/index/sec1_2_sp.png"
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_3.png" }),
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('mentor.home')
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("私も回答したいという方はこちら")
                                                ]),
                                                _: 1
                                            }, 8, ["href"])
                                        ])
                                    ])
                                ]),
                                _hoisted_13,
                                _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _hoisted_16,
                                    _createVNode(ImageFrame, {
                                        class: "pc",
                                        src: "images/index/sec2_pc.jpg"
                                    }),
                                    _createVNode(ImageFrame, {
                                        class: "sp",
                                        src: "images/index/sec2_sp.jpg"
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _hoisted_20,
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _hoisted_21,
                                                _createElementVNode("div", _hoisted_22, [
                                                    _hoisted_23,
                                                    _createVNode(ImageFrame, { src: "images/index/icon_1.svg" })
                                                ]),
                                                _hoisted_24
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_25,
                                                _createElementVNode("div", _hoisted_26, [
                                                    _hoisted_27,
                                                    _createVNode(ImageFrame, { src: "images/index/icon_2.svg" })
                                                ]),
                                                _hoisted_28
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_29,
                                                _createElementVNode("div", _hoisted_30, [
                                                    _hoisted_31,
                                                    _createVNode(ImageFrame, { src: "images/index/icon_3.svg" })
                                                ]),
                                                _hoisted_32
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_33,
                                                _createElementVNode("div", _hoisted_34, [
                                                    _hoisted_35,
                                                    _createVNode(ImageFrame, { src: "images/index/icon_4.svg" })
                                                ]),
                                                _hoisted_36
                                            ]),
                                            _createElementVNode("li", null, [
                                                _hoisted_37,
                                                _createElementVNode("div", _hoisted_38, [
                                                    _hoisted_39,
                                                    _createVNode(ImageFrame, { src: "images/index/icon_5.svg" })
                                                ]),
                                                _hoisted_40
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_41, [
                                            _hoisted_42,
                                            _createVNode(ImageFrame, { src: "images/index/sec4.jpg" })
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _hoisted_44,
                                    _hoisted_45,
                                    _createVNode(ImageFrame, { src: "images/index/sec5_1.jpg" }),
                                    _hoisted_46,
                                    _createVNode(ImageFrame, { src: "images/index/sec5_2.jpg" })
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                        _hoisted_49,
                                        _createElementVNode("ul", _hoisted_50, [
                                            _hoisted_51,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.plans, (option) => {
                                                return (_openBlock(), _createElementBlock("li", null, [
                                                    _createElementVNode("div", _hoisted_52, _toDisplayString(option.name), 1),
                                                    _createElementVNode("div", _hoisted_53, [
                                                        _hoisted_54,
                                                        _createElementVNode("p", _hoisted_55, _toDisplayString(showMonthlyAmount(option.id, option.monthly_amount)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_56, [
                                                        _hoisted_57,
                                                        _createTextVNode(" " + _toDisplayString(showQuestionCount(option.id, option.monthly_question_count)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_58, [
                                                        _hoisted_59,
                                                        _createTextVNode(" " + _toDisplayString(showAddQuestionAmount(option.id, option.additional_question_amount)), 1)
                                                    ]),
                                                    _hoisted_60,
                                                    _createElementVNode("div", _hoisted_61, [
                                                        _createElementVNode("a", {
                                                            class: "bt",
                                                            onClick: _withModifiers(($event) => (onClickSignUp(option.id)), ["prevent"]),
                                                            style: { "cursor": "pointer" }
                                                        }, "今すぐ登録", 8, _hoisted_62)
                                                    ])
                                                ]));
                                            }), 256))
                                        ]),
                                        _hoisted_63
                                    ])
                                ]),
                                _hoisted_64
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
